const styles = theme => ({
  root: {
    width: '100%'
  },
  input: {
    fontSize: '14px',
    width: '100%',
    height: '47px',
    borderRadius: '10px',
    opacity: 1,
    backgroundColor: '#ffffff',
    padding: '20px',
    fontFamily: 'Univia Pro',
    boxSizing: 'inherit'
  },
  helperText: {
    fontSize: '10px',
    marginLeft: '2%'
  },
  formlabel: {
    fontSize: '16px',
    textIndent: '35px'
  }
});

export default styles;

